export class BaseApi {
    constructor(apiCall) {
        this.apiCall = apiCall;
    }
}
//# sourceMappingURL=baseApi.js.map